export default {

	'general': {

		
	},
	'pages': {

	},
};
